module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/errormodal/errormodal.component.css
// module id = ./src/app/shared/component/errormodal/errormodal.component.css
// module chunks = main